<template>
  <v-row class="fill-height" align-content="center" justify="center" no-gutters>
    <v-col cols="12" class="text-center">
      <img src="@/assets/images/loader.svg" v-if="loading">
      <p class="text-center" v-else>{{message}}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      default: 'No data found.'
    }
  }
};
</script>